<template>
  <div class="container pap-form">
    <div v-if="showEnterEmailResult" class="mb-3">
      <AlertCard
        :type="resultType"
        :header="resultHeader"
        :message="resultMessage"
      >
        <div v-if="resultType === 'error'">
          To try again,
          <router-link
            :to="retryUrl"
            class="alert-card__text--link"
            @click.native="rerenderView"
            >click here.</router-link
          >
        </div>
      </AlertCard>
    </div>

    <Form
      v-if="showEnterEmailForm"
      key="resetPassword"
      :data="enterEmailForm"
      @form-validated="processSendResetLink($event)"
    >
      <template v-slot:topText>
        <p class="pap-form__text">
          Please enter and submit your
          <strong>current email address</strong> - the one you login with - and
          we'll send you a link to reset your password.
        </p>
      </template>
    </Form>
  </div>
</template>

<script>
import Form from '@/components/form/Form';
import AlertCard from '@/components/notifications/AlertCard';

import { Login } from '@/models/Login';

export default {
  name: 'PageChangeEmail',
  components: {
    Form,
    AlertCard,
  },
  data: function () {
    return {
      showEnterEmailResult: false,
      resultType: '',
      resultSuccessMsg: '',
      resultErrorMsg: '',
      enterEmailForm: this.enterEmailFormData(),
    };
  },

  computed: {
    retryUrl: function () {
      return '/reset-password';
      //   return '/reset-password?r=' + Date.now();
    },

    showEnterEmailForm: function () {
      return !this.showEnterEmailResult;
    },

    resultHeader: function () {
      if (this.resultType === 'success') {
        return 'Success!';
      }
      if (this.resultType === 'error') {
        return 'There was a problem...';
      }
      return '';
    },
    resultMessage: function () {
      return this.resultErrorMsg ? this.resultErrorMsg : this.resultSuccessMsg;
    },
  },

  methods: {
    // Create and return the 'change email' form data obj for the corresponding Form component
    enterEmailFormData: function () {
      var formData = {
        formTitle: 'Password Reset: Request Link',
        headerIconClass: 'fas fa-key mr-2',
        // headerIconClass: 'far fa-envelope mr-2',
        orderedFields: ['email'],
        submitButtonText: 'Send Password Reset Link',
        model: Login,
        fields: {
          email: {
            type: 'text',
            label: 'Current Login Email',
            placeholder: 'Current email address',
            maxLength: Login.getPropTruncateLength('email'),
            value: '',
            valid: null,
            errorMsg: '',
          },
        },
      };
      return formData;
    },

    // test: function () {
    //   console.log('parent', this.$parent);
    // },
    rerenderView: function () {
      this.$parent.rerenderView();
    },
    processSendResetLink: async function (formData) {
      try {
        // throw Error;
        await this.$fapi.sendUserResetPasswordEmail(formData.email);

        this.resultType = 'success';
        this.resultSuccessMsg = `The link to reset your password has been sent. Please check your email: ${formData.email}`;
      } catch (err) {
        this.resultType = 'error';
        this.resultErrorMsg =
          'Failed to send the email with the reset password link.';
      }
      this.showEnterEmailResult = true;
    },
  },
};
</script>

<style>
</style>